import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';

export interface IChips {
	id: string;
	name: string;
}

@Component({
	selector: 'au-chips',
	templateUrl: './au-chips.component.html',
	styleUrls: ['./au-chips.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class AuChipsComponent implements OnChanges {
	@Input()
	chips: IChips[] = [];

	@Input()
	preSelectedChips: IChips[];

	@Output()
	selectionChanges = new EventEmitter<IChips[]>();

	selectedChips: IChips[] = [];

	constructor(private cdRef: ChangeDetectorRef) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.preSelectedChips) {
			this.selectedChips = changes.preSelectedChips.currentValue;
			this.cdRef.markForCheck();
		}
	}

	onChipsClick(item: IChips): void {
		const isInArray = this.selectedChips.find(chips => chips.id === item.id);

		if (isInArray) {
			this.selectedChips.splice(
				this.selectedChips.findIndex(chips => {
					return chips.id === item.id;
				}),
				1
			);
		} else {
			this.selectedChips.push(item);
		}

		this.selectionChanges.emit(this.selectedChips);
	}

	chipsHasActiveClass(item: IChips): boolean {
		return !!this.selectedChips.find(chips => chips.id === item.id);
	}
}
